export const linksUrl = 'links/';
export const linkUrl = (linkId: string) => `links/${linkId}/`;
